// extracted by mini-css-extract-plugin
export default {"container":"home_container__w_07g","title":"home_title__1EJPk"};